export enum RegistrationType {
  PERSONAL = 'PERSONAL',
  BUSINESS = 'BUSINESS',

}
